/**
 * UUID Generation Utility
 * Uses native crypto.randomUUID() with fallback for older browsers
 */

/**
 * Generate a RFC4122 version 4 UUID
 * @returns {string} UUID string
 */
export const generateUUID = () => {
  // Use native crypto.randomUUID if available (modern browsers)
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for older browsers
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
